import {useEffect, useState} from 'react';
import {hasWindow} from 'utils/functions';

interface WindowsSize {
  width: number | undefined;
  height: number | undefined;
}

export const useWindowSize = () => {
	const [windowSize, setWindowSize] = useState<WindowsSize>(() => {
		if (hasWindow()) {
			return {
				width: window.innerWidth,
				height: window.innerHeight,
			};
		}
		return {
			width: undefined,
			height: undefined,
		};
	});

	useEffect(() => {
		if (!hasWindow()) {
			return;
		}

		const handleResize = () => {
			setWindowSize({
				width: window.innerWidth,
				height: window.innerHeight,
			});
		};

		window.addEventListener('resize', handleResize);
		handleResize();
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return windowSize;
};
